import { removeNull, resetAttribute, applyFormerNames, asRows, attachCreateTime } from '@/utils/handleData.js'
import { Message } from 'element-ui'

function notifyPersonSave(res, successText) {
  if (!res || res.code !== 200) return
  const data = res.data || {}
  if (data.phoneDup) {
    const names = (Array.isArray(data.dupUserNames) ? data.dupUserNames : [])
      .filter((item) => item)
      .join('、')
    const account = names ? `账号 ${names}` : '其他账号'
    Message({
      message: `保存成功。手机号码与${account}重复，下次登录需密码和短信两种方式交叉验证`,
      type: 'warning',
      duration: 6000
    })
  } else {
    Message({ message: successText, type: 'success' })
  }
}

function asPersonRows(rows) {
  if (Array.isArray(rows)) return rows
  if (rows && Array.isArray(rows.result)) return rows.result
  if (rows && typeof rows === 'object' && (rows.uid || rows.personUid || rows.name)) {
    return [rows]
  }
  return []
}

function mapPersonOptions(rows, rootState, commit) {
  const list = asPersonRows(rows)
  list.forEach((item, index) => {
    item.personUid = item.personUid || item.personuid || item.uid
    item.personName = item.personName || item.personname || item.name
    item.idcard = item.idcard || item.idCard || item.id_card || ''
    item.phoneNumber =
      item.phoneNumber || item.phone_number || item.telphoneNum || ''
    item.faceSluid = item.faceSluid || item.facesluid || item.face_sluid
    if (item.faceSluid) {
      const key = 'personFace' + (index + 1)
      commit(
        'pictureSet',
        { key: key, value: [item.faceSluid], type: 'face' },
        { root: true }
      )
      if (rootState.pictures[key] && rootState.pictures[key].length) {
        item.image = rootState.pictures[key][0].url
      }
    }
  })
  return resetAttribute(list, 'personName', 'personUid')
}

export default {
  namespaced: true,
  state: {
    personNames: [], // 缓存按照姓名或身份证全称查询的人员
    personList: {}, // 缓存人员信息列表当前页
    personBaseInfo: {}, // 缓存人员身份信息及基础信息
    bankCard: [], // 缓存人员银行卡
    signature: [], // 缓存人员电子签名
    qualification: [], // 缓存人员资格证书
    experience: [], // 缓存项目履历
    perBusiness: [], // 缓存当前选择人员的当前工种
    perBackCard: [], // 缓存当前选择人员的银行卡卡号及名称
    perSignature: [], // 缓存当前选择人员的电子签名名称及图片
    archiveLockAt: 0,
    archiveLock: {
      walkinDate: '',
      projectUid: ''
    },
    aligned: false
  },
  actions: {
    // 根据用户名获取人员uid
    async getPeronUid({ dispatch }, useruid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/useruid',
          data: useruid ? { useruid: useruid } : ''
        },
        { root: true }
      )
      return res && res.data ? res.data : ''
    },
    // 他人通过姓名或身份证号查询人员uid
    async checkPeronUid({ rootState, commit, dispatch }, val) {
      var personNames = []
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/buildtype/personuid',
          data: { personQuery: val }
        },
        { root: true }
      )
      if (res.data) {
        personNames = mapPersonOptions(res.data, rootState, commit)
        commit(
          'baseSet',
          { module: 'person', key: 'personNames', value: personNames },
          { root: true }
        )
      }
      return personNames
    },
    async searchPersonLibrary({ rootState, commit, dispatch, state }, val) {
      var personNames = []
      if (!val) {
        return state.personNames
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/personinfo/search',
          data: { query: val },
          noErrorMsg: true
        },
        { root: true }
      )
      if (res && res.code === 200) {
        personNames = mapPersonOptions(res.data || [], rootState, commit)
        commit(
          'baseSet',
          { module: 'person', key: 'personNames', value: personNames },
          { root: true }
        )
        return personNames
      }
      return dispatch('checkPeronUid', val)
    },
    async echoPersonOption({ rootState, commit, dispatch, state }, data) {
      const uid = data && (data.uid || data.personUid)
      const name = data && (data.name || data.personName)
      if (!uid) {
        return state.personNames
      }
      const exists = (state.personNames || []).some(
        (item) => item && String(item.value) === String(uid)
      )
      if (exists) {
        return state.personNames
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/personinfo',
          data: {
            uid: uid,
            fields: 'uid,name,idcard,faceSluid,phoneNumber'
          },
          noErrorMsg: true
        },
        { root: true }
      )
      const rows = res && res.data ? res.data : []
      const mapped = mapPersonOptions(asPersonRows(rows), rootState, commit)
      const option = mapped.length
        ? mapped[0]
        : { label: name || uid, value: uid }
      const personNames = [option].concat(state.personNames || [])
      commit(
        'baseSet',
        { module: 'person', key: 'personNames', value: personNames },
        { root: true }
      )
      return personNames
    },
    // 上传身份证成功后识别身份信息
    async analysisIdcard({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/analysis/compare/idcard', data: data },
        { root: true }
      )
      return res
    },
    // 根据身份证号获取年龄及籍贯
    async getProvincecity({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/person/provincecity', data: data },
        { root: true }
      )
      return res
    },
    // 上传银行卡成功后识别身份信息
    async analysisBankcard({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/analysis/compare/bankcard', data: data },
        { root: true }
      )
      return res
    },
    // 获取人员当前工种（主业 + 其他可从业，按名称去重，主业排前）
    async getCurrentBusiness({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/personuidbusiness',
          data: { personUid: uid }
        },
        { root: true }
      )
      const rows = asRows(res && res.data)
      rows.sort((a, b) => {
        const ta = String(a.type) === '1' ? 0 : 1
        const tb = String(b.type) === '1' ? 0 : 1
        return ta - tb
      })
      const seen = {}
      const perBusiness = []
      rows.forEach((item) => {
        const name = item.businessType || item.label
        if (!name || seen[name]) return
        seen[name] = true
        perBusiness.push(
          Object.assign({}, item, {
            label: name,
            value: name
          })
        )
      })
      commit(
        'baseSet',
        { module: 'person', key: 'perBusiness', value: perBusiness },
        { root: true }
      )
      return perBusiness
    },
    async addPersonOtherBusiness({ dispatch }, data) {
      const personUid = data && (data.personUid || data.uid)
      const picked = data && (data.business || data.otherBusiness)
      const adding = (Array.isArray(picked) ? picked : [picked])
        .map((item) => String(item || '').trim())
        .filter(Boolean)
      if (!personUid) {
        Message({ message: '请先选择劳务人员', type: 'warning' })
        return { code: 400 }
      }
      if (!adding.length) {
        Message({ message: '请选择要添加的工种', type: 'warning' })
        return { code: 400 }
      }
      const registered = await dispatch('getCurrentBusiness', personUid)
      const allNames = {}
      const otherNames = []
      ;(registered || []).forEach((item) => {
        const name = item.label || item.businessType || item.value
        if (!name) return
        allNames[name] = true
        if (String(item.type) !== '1' && otherNames.indexOf(name) === -1) {
          otherNames.push(name)
        }
      })
      const dup = adding.filter((name) => allNames[name])
      if (dup.length) {
        Message({
          message: '工种「' + dup.join('、') + '」已在人员档案中，请勿重复添加',
          type: 'warning'
        })
        return { code: 400 }
      }
      const merged = otherNames.slice()
      adding.forEach((name) => {
        if (merged.indexOf(name) === -1) {
          merged.push(name)
        }
      })
      if (merged.length > 5) {
        Message({
          message: '其他可从业工种最多只能选择5项',
          type: 'warning'
        })
        return { code: 400 }
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/list/personinfo',
          data: { uid: personUid, otherBusiness: merged },
          msg: '添加工种成功'
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await dispatch('getCurrentBusiness', personUid)
      }
      return res
    },
    // 获取人员银行卡
    async getBackCard({ commit, dispatch }, uid) {
      if (!uid) {
        commit(
          'baseSet',
          { module: 'person', key: 'perBackCard', value: [] },
          { root: true }
        )
        return []
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/bankcard',
          data: { fields: 'uid,bankName,cardNum', personUid: uid }
        },
        { root: true }
      )
      const rows = asRows(res && res.data)
      rows.forEach((item) => {
        item.uid = item.uid || item.UID || item.cardUid || item.carduid || ''
        item.bankName = item.bankName || item.bankname || item.bank_name || ''
        item.cardNum = item.cardNum || item.cardnum || item.card_num || ''
        item.label = (item.bankName || '银行卡') + '\xa0\xa0\xa0' + item.cardNum
      })
      const perBackCard = resetAttribute(rows, 'label', 'uid')
      commit(
        'baseSet',
        { module: 'person', key: 'perBackCard', value: perBackCard },
        { root: true }
      )
      return perBackCard
    },
    // 批量导入个人档案
    async upLoadPerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfos',
          data: data,
          msg: '导入人员档案成功'
        },
        { root: true }
      )
      return res
    },
    // 批量导入个人银行卡
    async upLoadBankCard({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/bankcards',
          data: data,
          msg: '导入人员银行卡成功'
        },
        { root: true }
      )
      return res
    },
    // 批量导入个人签名
    async upLoadSignature({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/elec/websignatures',
          data: data,
          msg: '导入人员签名成功'
        },
        { root: true }
      )
      return res
    },
    // 新增个人档案
    async addPerson({ commit, dispatch, rootState }, data) {
      if (data && !Array.isArray(data)) {
        if (
          !data.phoneNumber &&
          rootState.formValues.baseInfo &&
          rootState.formValues.baseInfo.phoneNumber
        ) {
          data.phoneNumber = rootState.formValues.baseInfo.phoneNumber
        }
        if (
          rootState.pageStatus.person === 'adminAdd' ||
          rootState.pageStatus.identity === 'adminAdd'
        ) {
          data.adminAdd = true
        }
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo',
          data: data
        },
        { root: true }
      )
      notifyPersonSave(res, '新增人员档案成功')
      if (res.data && res.data.personUid) {
        if (data && data.adminAdd) {
          commit('pageStatusSet', { key: 'person', value: 'edit' }, { root: true })
          commit(
            'pageStatusSet',
            { key: 'identity', value: 'edit' },
            { root: true }
          )
          commit(
            'pageStatusSet',
            { key: 'baseInfo', value: 'edit' },
            { root: true }
          )
        }
        commit(
          'currentUidsSet',
          {
            key: 'person',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'baseInfo',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'identity',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'bankCard',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'signature',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'qualification',
            value: res.data.personUid
          },
          { root: true }
        )
        commit(
          'currentUidsSet',
          {
            key: 'experience',
            value: res.data.personUid
          },
          { root: true }
        )
      }
      return res
    },
    // 新增个人银行卡
    async addPersonBankCard({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/bankcard',
          data: data,
          msg: '新增人员银行卡成功'
        },
        { root: true }
      )
      return res
    },
    // 新增个人签名
    async addPersonSignature({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/elec/websignature',
          data: data,
          msg: '新增个人签名成功'
        },
        { root: true }
      )
      return res
    },
    // 新增个人资格证书
    async addPersonQualification({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/certificate',
          data: data,
          msg: '新增人员资格证书成功'
        },
        { root: true }
      )
      return res
    },
    // 删除个人银行卡
    async deletePersonBankCard({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/list/bankcard',
          data: { uid: uid },
          msg: '删除人员银行卡成功'
        },
        { root: true }
      )
      return res
    },
    // 删除个人签名
    async deletePersonSignature({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/elec/signature',
          data: { uid: uid },
          msg: '删除个人签名成功'
        },
        { root: true }
      )
      return res
    },
    // 删除个人资格证书
    async deletePersonQualification({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/list/certificate',
          data: { uid: uid },
          msg: '删除人员银行卡成功'
        },
        { root: true }
      )
      return res
    },
    // 获取人员信息列表
    async getPersonList({ rootState, commit, dispatch }, idcard) {
      if (!rootState.person.aligned) {
        try {
          await dispatch('alignPersonUser')
        } catch (e) {
          /* ignore */
        }
        commit(
          'baseSet',
          { module: 'person', key: 'aligned', value: true },
          { root: true }
        )
      }
      var queryValues = JSON.parse(JSON.stringify(rootState.queryValues.person))
      queryValues.page = rootState.page.person
      queryValues.limit = rootState.limit.person
      queryValues = removeNull(queryValues)
      if (idcard) {
        queryValues.query = idcard
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/person/baseinfo', data: queryValues },
        { root: true }
      )
      if (res.data && !idcard) {
        await dispatch('fillPersonArchiveStatus', res.data.result || [])
        commit(
          'baseSet',
          { module: 'person', key: 'personList', value: res.data },
          { root: true }
        )
      } else if (!res.data) {
        commit(
          'baseSet',
          { module: 'person', key: 'personList', value: {} },
          { root: true }
        )
      }
      return res.data ? res.data : {}
    },
    // 查询单个人员全部信息
    async getPersonInfo({ rootState, dispatch }, uid) {
      const pageName = rootState.currentStep.step.slice(0, -4)
      const personUid = uid ? uid : rootState.currentUids[pageName]
      const personBaseInfo = await dispatch('getPersonBaseInfo', personUid)
      const bankCard = await dispatch('getPersonBankCard', personUid)
      const signature = await dispatch('getPersonSignature', personUid)
      const qualification = await dispatch('getPersonQualification', personUid)
      const experience = await dispatch('getPersonExperience', personUid)
      const personInfo = {
        identity: personBaseInfo,
        baseInfo: personBaseInfo,
        bankCard: bankCard,
        signature: signature,
        qualification: qualification,
        experience: experience
      }
      return personInfo
    },
    // 管理权限外用户查看人员部分信息
    async checkPersonInfo({ rootState, dispatch }, uid) {
      const pageName = rootState.currentStep.step.slice(0, -4)
      const personUid = uid ? uid : rootState.currentUids[pageName]
      const personBaseInfo = await dispatch('checkPersonnelBaseInfo', personUid)
      const qualification = await dispatch('getPersonQualification', personUid)
      const experience = await dispatch('getPersonExperience', personUid)
      const personInfo = {
        identity: personBaseInfo,
        baseInfo: personBaseInfo,
        qualification: qualification,
        experience: experience
      }
      return personInfo
    },
    // 管理权限外用户查看人员档案身份及基础信息
    async checkPersonnelBaseInfo({ commit, dispatch }, uid) {
      const percentage = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/person/basecentagepersonuid',
          data: { personUid: uid }
        },
        { root: true }
      )
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/person/otherbaseinfo',
          data: { personUid: uid }
        },
        { root: true }
      )
      var personBaseInfo = res.data ? res.data : {}
      personBaseInfo.uid = uid
      personBaseInfo.percentage = percentage.data
      personBaseInfo.age = '**岁'
      personBaseInfo.nation = '**族'
      personBaseInfo.birthday = '**年**月**日'
      personBaseInfo.nativePlace = '**省（自治区）**市（州）'
      personBaseInfo.idcard = '******************'
      personBaseInfo.licenceOrg = '***公安局'
      personBaseInfo.address =
        '**省（自治区）**市（州）**区（县）**镇（街道）**'
      personBaseInfo.workFlag === '***'
      personBaseInfo.workFlagIcon = '#icon-dengdai'
      personBaseInfo.fileLists = {}
      personBaseInfo.fileLists.faceSluid = [
        {
          url: 'data:image/jpeg;base64,' + personBaseInfo.faceimage,
          uid: personBaseInfo.faceSluid
        }
      ]
      personBaseInfo.fileLists.idcardFrontSluid = [
        { url: require('@/assets/img/front.png'), uid: 'front' }
      ]
      personBaseInfo.fileLists.idcardBackSluid = [
        { url: require('@/assets/img/back.png'), uid: 'back' }
      ]
      personBaseInfo.reportSlUid = []
      personBaseInfo.fileLists.reportSlUid = []
      personBaseInfo.otherBusinessName = personBaseInfo.otherBusiness
      if (personBaseInfo.otherBusiness) {
        personBaseInfo.otherBusiness = personBaseInfo.otherBusiness
          .replace(/\s*/g, '')
          .split(',')
      } else {
        personBaseInfo.otherBusiness = []
      }
      if (personBaseInfo.isJoinSocial === 'true') {
        personBaseInfo.joinSocial = '是'
      } else if (personBaseInfo.isJoinSocial === 'false') {
        personBaseInfo.joinSocial = '否'
      }
      if (personBaseInfo.isJoinCooperative === 'true') {
        personBaseInfo.joinCooperative = '是'
      } else if (personBaseInfo.isJoinCooperative === 'false') {
        personBaseInfo.joinCooperative = '否'
      }
      if (personBaseInfo.isJoinUnion === '1') {
        personBaseInfo.joinUnion = '是'
      } else if (personBaseInfo.isJoinUnion === '0') {
        personBaseInfo.joinUnion = '否'
        personBaseInfo.joinUnionTime = ''
      }
      commit(
        'baseSet',
        { module: 'person', key: 'personBaseInfo', value: personBaseInfo },
        { root: true }
      )
      return personBaseInfo
    },
    // 获取单个人员身份及基础信息
    async getPersonBaseInfo({ rootState, commit, dispatch }, uid) {
      const percentage = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/person/basecentagepersonuid',
          data: { personUid: uid }
        },
        { root: true }
      )
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/baseinfodetail',
          data: { personUid: uid }
        },
        { root: true }
      )
      // console.log(res)
      var personBaseInfo = res.data ? res.data : {}
      personBaseInfo.uid = uid
      personBaseInfo.nativePlace = personBaseInfo.provinceCityCounty
      personBaseInfo.percentage = percentage.data
      try {
        const extra = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/person/list/personinfo/archivestatus',
            data: { uids: uid },
            noErrorMsg: true
          },
          { root: true }
        )
        const row = Array.isArray(extra.data) ? extra.data[0] : extra.data
        if (row) {
          personBaseInfo.formerName = row.formerName || row.formername || ''
        }
      } catch (e) {
        personBaseInfo.formerName = personBaseInfo.formerName || ''
      }
      personBaseInfo.otherBusinessName = personBaseInfo.otherBusiness
      personBaseInfo.otherBusiness = personBaseInfo.otherBusiness
        ? personBaseInfo.otherBusiness.replace(/\s*/g, '').split(',')
        : []
      personBaseInfo.reportSlUid = personBaseInfo.reportSlUid
        ? personBaseInfo.reportSlUid.replace(/\s*/g, '').split(',')
        : []
      commit(
        'pictureSet',
        { key: 'reportSlUid', value: personBaseInfo.reportSlUid },
        { root: true }
      )
      personBaseInfo.fileLists = {}
      personBaseInfo.fileLists.reportSlUid = rootState.pictures.reportSlUid
      personBaseInfo.fileLists.reportSlUid.forEach((item, index) => {
        item.name = '体检报告' + (index + 1)
      })
      const sharedDefault = '08e62f56-3ee1-4d1b-a3d0-8a3156216321'
      let faceId = personBaseInfo.faceSluid
      if (!faceId || faceId === sharedDefault) {
        personBaseInfo.faceSluid = ''
        const def = await dispatch(
          'baseRequest',
          { method: 'GET', url: '/person/list/personinfo/defaultface', noErrorMsg: true },
          { root: true }
        )
        faceId = def && def.data ? def.data : sharedDefault
      }
      commit(
        'pictureSet',
        { key: 'faceSluid', type: 'face', value: [faceId] },
        { root: true }
      )
      commit(
        'pictureSet',
        { key: 'idcardFrontSluid', value: [personBaseInfo.idcardFrontSluid] },
        { root: true }
      )
      commit(
        'pictureSet',
        { key: 'idcardBackSluid', value: [personBaseInfo.idcardBackSluid] },
        { root: true }
      )
      personBaseInfo.fileLists.faceSluid = rootState.pictures.faceSluid
      personBaseInfo.fileLists.idcardFrontSluid =
        rootState.pictures.idcardFrontSluid
      personBaseInfo.fileLists.idcardBackSluid =
        rootState.pictures.idcardBackSluid
      if (personBaseInfo.workFlag === '已就业') {
        personBaseInfo.workFlagIcon = '#icon-_jiuyechuangye'
      } else {
        personBaseInfo.workFlagIcon = '#icon-dengdai'
      }
      if (personBaseInfo.isJoinSocial === 'true') {
        personBaseInfo.joinSocial = '是'
      } else if (personBaseInfo.isJoinSocial === 'false') {
        personBaseInfo.joinSocial = '否'
      }
      if (personBaseInfo.isJoinCooperative === 'true') {
        personBaseInfo.joinCooperative = '是'
      } else if (personBaseInfo.isJoinCooperative === 'false') {
        personBaseInfo.joinCooperative = '否'
      }
      if (personBaseInfo.isJoinUnion === '1') {
        personBaseInfo.joinUnion = '是'
      } else if (personBaseInfo.isJoinUnion === '0') {
        personBaseInfo.joinUnion = '否'
        personBaseInfo.joinUnionTime = ''
      }
      commit(
        'baseSet',
        { module: 'person', key: 'personBaseInfo', value: personBaseInfo },
        { root: true }
      )
      return personBaseInfo
    },
    // 获取单个人员银行卡信息
    async getPersonBankCard({ rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/bankcard',
          data: { personUid: uid ? uid : rootState.currentUids.person }
        },
        { root: true }
      )
      // console.log(res)
      var bankCard = asRows(res && res.data)
      bankCard.forEach((item, index) => {
        attachCreateTime(item)
        item.uid = item.uid || item.UID || item.cardUid || item.carduid || ''
        item.bankName = item.bankName || item.bankname || item.bank_name
        item.cardNum = item.cardNum || item.cardnum || item.card_num
        item.positivePhoto =
          item.positivePhoto || item.positivephoto || item.positive_photo
        item.value = item.uid
        item.titleText = item.bankName + '\xa0\xa0\xa0\xa0' + item.cardNum
        item.fileLists = {}
        const key = 'backCard' + (index + 1)
        commit(
          'pictureSet',
          { key: key, value: [item.positivePhoto] },
          { root: true }
        )
        item.fileLists.positivePhoto = rootState.pictures[key]
      })
      commit(
        'baseSet',
        { module: 'person', key: 'bankCard', value: bankCard },
        { root: true }
      )
      return bankCard
    },
    // 获取单个人员资格证书信息
    async getPersonQualification({ rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/certificate',
          data: { personUid: uid ? uid : rootState.currentUids.person }
        },
        { root: true }
      )
      // console.log(res)
      var qualification = asRows(res && res.data)
      qualification.forEach((item, index) => {
        attachCreateTime(item)
        if (item.certificateEndate) {
          const d = new Date()
          const endTime = new Date(item.certificateEndate)
          if (
            endTime.getFullYear() > d.getFullYear() ||
            (endTime.getFullYear() === d.getFullYear() &&
              endTime.getMonth() > d.getMonth()) ||
            (endTime.getFullYear() === d.getFullYear() &&
              endTime.getMonth() === d.getMonth() &&
              endTime.getDay() > d.getDay())
          ) {
            item.typeIcon = 'el-icon-circle-check'
            item.status = '有效'
          } else {
            item.typeIcon = 'el-icon-circle-close'
            item.status = '过期'
          }
        } else {
          if (item.isDisease === '有效') {
            item.typeIcon = 'el-icon-circle-check'
            item.status = '有效'
          } else {
            item.typeIcon = 'el-icon-circle-close'
            item.status = item.isDisease || '未知'
          }
          item.certificateStatus = item.isDisease
        }
        item.fileLists = {}
        const key = 'qualification' + (index + 1)
        commit(
          'pictureSet',
          { key: key, value: [item.licensingSjuid] },
          { root: true }
        )
        item.fileLists.licensingSjuid = rootState.pictures[key]
      })
      commit(
        'baseSet',
        { module: 'person', key: 'qualification', value: qualification },
        { root: true }
      )
      return qualification
    },
    // 获取单个人员项目履历信息
    async getPersonExperience({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/historydetails',
          data: { personUid: uid }
        },
        { root: true }
      )
      // console.log(res)
      var experience = asRows(res && res.data)
      experience.forEach((item) => {
        item.totalLock = item.totalLock * 100 + '%'
        if (item.walkoffDate) {
          item.titleText =
            item.walkinDate +
            '\xa0\xa0\xa0—\xa0\xa0\xa0' +
            item.walkoffDate +
            '\xa0\xa0\xa0\xa0\xa0\xa0' +
            item.vProjectName
        } else {
          item.titleText =
            item.walkinDate +
            '\xa0\xa0\xa0—\xa0\xa0\xa0' +
            '至今' +
            '\xa0\xa0\xa0\xa0\xa0\xa0' +
            item.vProjectName
        }
        if (!item.walkoffDate) {
          item.walkoffDate = '未退场'
        }
        if (item.isForeman === '劳务人员') {
          item.typeIcon = 'iconfont icon-office-supplies-fill'
          item.status = item.business
        } else if (item.isForeman === '管理人员') {
          item.typeIcon = 'iconfont icon-bussiness-man-fill'
          item.status = item.jobTitle
        } else {
          item.typeIcon = ''
          item.status = ''
        }
      })
      commit(
        'baseSet',
        { module: 'person', key: 'experience', value: experience },
        { root: true }
      )
      return experience
    },
    // 获取单个人员电子签名信息
    async getPersonSignature({ rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/person/personuidelector',
          data: { personUid: uid ? uid : rootState.currentUids.person }
        },
        { root: true }
      )
      // console.log(res)
      var signature = asRows(res && res.data)
      signature.forEach((item, index) => {
        attachCreateTime(item)
        item.uid =
          item.uid || item.UID || item.electorUid || item.electoruid || ''
        item.signatureUid =
          item.signatureUid ||
          item.signatureuid ||
          item.electorGrade ||
          item.elector_grade
        item.electorName =
          item.electorName || item.electorname || item.elector_name
        if (!item.projectName) {
          item.projectName = '无'
          item.validCondition = '无'
        }
        item.signatureName = item.electorName
        item.fileLists = {}
        const key = 'signature' + (index + 1)
        commit(
          'pictureSet',
          { key: key, value: [item.signatureUid], type: 'signature' },
          { root: true }
        )
        item.fileLists.signatureUid = rootState.pictures[key]
        if (item.fileLists.signatureUid.length) {
          item.titleImage = item.fileLists.signatureUid[0].url
        }
        item.value = item.signatureUid || item.uid
        item.label = item.electorName || item.signatureName || '电子签名'
        item.image = item.titleImage
      })
      commit(
        'baseSet',
        { module: 'person', key: 'signature', value: signature },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'person', key: 'perSignature', value: signature },
        { root: true }
      )
      return signature
    },
    // 检查人员是否缺少银行卡或电子签名
    async checkPersonsMissing({ dispatch }, { persons, type }) {
      const missing = []
      await Promise.all(
        (persons || []).map(async (item) => {
          const uid = item.personUid || item.person_uid
          if (!uid) return
          if (type === 'bank') {
            const res = await dispatch(
              'baseRequest',
              {
                method: 'GET',
                url: '/person/list/bankcard',
                data: { fields: 'uid,bankName,cardNum', personUid: uid }
              },
              { root: true }
            )
            if (!res.data || !res.data.length) missing.push(item)
          } else {
            const res = await dispatch(
              'baseRequest',
              {
                method: 'GET',
                url: '/query/person/personuidelector',
                data: { personUid: uid }
              },
              { root: true }
            )
            const list = res.data || []
            if (!list.some((s) => s.signatureUid)) missing.push(item)
          }
        })
      )
      return missing
    },
    // 编辑人员身份及基础信息
    async editPerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/list/personinfo',
          data: data
        },
        { root: true }
      )
      notifyPersonSave(res, '编辑人员信息成功')
      return res
    },
    // 编辑人员银行卡
    async editPersonBankCard({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/list/bankcard',
          data: data,
          msg: '编辑人员银行卡信息成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑人员资格证书
    async editPersonQualification({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/list/certificate',
          data: data,
          msg: '编辑人员资格证书成功'
        },
        { root: true }
      )
      return res
    },
    // 查询人员二维码
    async getPersonQcode({ rootState, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/make/qrcode',
          data: { personUid: uid ? uid : rootState.currentUids.person }
        },
        { root: true }
      )
      // console.log(res)
      var qcodeInfo = res.data ? res.data : {}
      if (!qcodeInfo.qcodeUrl && qcodeInfo.qcode) {
        qcodeInfo.qcodeUrl = qcodeInfo.qcode
      }
      if (qcodeInfo.qcodeUrl) {
        qcodeInfo.qcodeUrl = String(qcodeInfo.qcodeUrl).replace(/[\r\n]/g, '')
      }
      if (qcodeInfo.qcode) {
        qcodeInfo.qcode = String(qcodeInfo.qcode).replace(/[\r\n]/g, '')
      }
      if (!qcodeInfo.qcodeUrl && uid) {
        qcodeInfo.qcodeUrl = uid
      }
      qcodeInfo.project = qcodeInfo.project || ''
      qcodeInfo.leftText = qcodeInfo.leftText || '平安工地'
      qcodeInfo.rightText = qcodeInfo.rightText || '以人为本'
      return qcodeInfo
    },
    async alignPersonUser({ dispatch }) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo/align',
          noErrorMsg: true
        },
        { root: true }
      )
    },
    async fillPersonArchiveStatus({ dispatch }, rows) {
      if (!rows || !rows.length) {
        return rows
      }
      const uids = rows
        .map((item) => item.uid || item.personUid)
        .filter((item) => item)
      if (!uids.length) {
        rows.forEach((item) => {
          item.archiveStatus = '1'
          item.archiveStatusName = '正常'
          item.disabledButtons = [3, 4]
        })
        return rows
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/personinfo/archivestatus',
          data: { uids: uids.join(',') },
          noErrorMsg: true
        },
        { root: true }
      )
      const statusMap = {}
      const list = Array.isArray(res.data) ? res.data : []
      list.forEach((item) => {
        const uid = item.uid || item.UID
        if (uid) {
          statusMap[uid] = item.archiveStatus || item.archivestatus || '1'
        }
      })
      rows.forEach((item) => {
        const uid = item.uid || item.personUid
        const status = statusMap[uid] || '1'
        item.archiveStatus = status
        item.archiveStatusName = status === '0' ? '封存' : '正常'
        item.disabledButtons = status === '0' ? [2] : [3, 4]
      })
      applyFormerNames(rows, list)
      return rows
    },
    async sealPersons({ dispatch }, uids) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo/seal',
          data: { uids: uids },
          msg: '封存成功'
        },
        { root: true }
      )
    },
    async unsealPersons({ dispatch }, uids) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo/unseal',
          data: { uids: uids },
          msg: '解封成功'
        },
        { root: true }
      )
    },
    async purgePerson({ dispatch }, uid) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo/purge',
          data: { uids: [uid] },
          msg: '删除成功'
        },
        { root: true }
      )
    },
    async purgePersonUser({ dispatch }, uid) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/list/personinfo/purgeuser',
          data: { userUid: uid },
          msg: '删除成功'
        },
        { root: true }
      )
    }
  }
}
